var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "H1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-63 65 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.9,72.5c1.3-3.6,5.4-5.5,9-4.2s5.5,5.4,4.2,9s-5.4,5.5-9,4.2C-9.4,80.1-11.2,76.1-9.9,72.5z M-15.1,146.1l14.3-9.9 c1.2-0.9,2-2.3,1.9-3.9c-0.1-0.7-0.3-1.3-0.6-1.8l-1.9-3.8l4.8,3.1L6.1,145c0.4,2.4,2.7,4,5,3.5c2.4-0.4,4-2.7,3.5-5l-3-17.1 c-0.1-0.5-0.2-1-0.5-1.4c-0.3-0.6-0.8-1-1.3-1.4l-12.7-9.9l1.3-14.8l1.5,2.6c0.5,0.8,1.2,1.4,2.1,1.6l13.4,3.6 c1.9,0.5,3.8-0.6,4.3-2.4c0.5-1.9-0.6-3.8-2.4-4.3l-12-3.3l-3.7-6.5l22.5-3.9c1.9-0.3,3.2-2.1,2.8-4c-0.3-1.9-2.1-3.2-4-2.8 l-29.4,5.1c-4.8,0.8-8.2,4.7-8.6,9.3l0,0l-1.9,21.6c-0.1,0.8,0,1.7,0.1,2.5c0.2,1.3,0.7,2.4,1.3,3.5l0.1,0.2 c0.1,0.1,0.1,0.2,0.2,0.3l6,9.4L-20,139c-2,1.4-2.5,4.1-1.1,6.1S-17,147.5-15.1,146.1z M-63,147.5l0.2-2.8l127.9,10.7l-0.2,2.8 L-63,147.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.9c81e9366536b114ab6da370ca59b200.svg";
export { ForwardRef as ReactComponent };